export const m = {
  EnterID: "Haz clic para introducir el ID de Tada",
  "select-specifications":
    "Haz clic para seleccionar la especificación de recarga",
  "check-account": "Prueba la cuenta de recarga",
  whatID: "¿Qué es el ID de Tada?",
  getID: "Introduce el ID de Tada",
  maskgetID: "Introduce el ID de Tada",
  "toastTipsPlease-format-error": "La forma de entrada es incorrecta",
  "toastTipsPlease-no-exist": "El ID no existe",
  toastTipsPlease: "Comprueba primero la cuenta de recarga",
  "common-problem": "Preguntas frecuentes",
  "transaction-succeeded": "Transacción hecha",
  "transaction-failed": "Transacción fallida",
  "transaction-cancel": "Transacción cancelada",
  "whether-account":
    "1. ¿Cómo puedo verificar la transacción después de recargar?",
  "answer-whether-account":
    "Después de la recarga, puedes volver a la APP [Mi]-[Billetera] para comprobar el Diamante",
  "no-account": "2.¿Qué pasa si no recibo el Diamante después de recargar?",
  "answer-no-account":
    "Por favor, envía tu pregunta en la APP [Noticias]-[Noticias oficiales]-[Comentarios y ayuda], y proporciona las siguientes informaciones, nuestro servicio de atención al cliente te ayudará.",
  "recharge-money": "1. Importe de la recarga e ID de la cuenta",
  "recharge-time": "2. Tiempo y fecha de recarga",
  "recharge-shot": "3. Captura de pantalla del pago exitoso",
  "recharge-wrong":
    "3.¿Qué debo hacer si realizo una recarga incorrecta a una cuenta incorrecta?",
  "answer-recharge-wrong":
    "Confirma cuidadosamente el ID de la cuenta de recarga y las informaciones del importe de la recarga antes de introducir la contraseña de pago. La recarga incorrecta no puede ser reembolsada. Si ocurre una recarga incorrecta, puedes ponerte en contacto con el usuario de la recarga real y negociar con la otra parte si está dispuesto a compensarte por la recarga.",
  refund: "4.Reembolso",
  "answer-refund":
    "¡Lo siento! Tada no admite actualmente ninguna forma de reembolso.",
  "buy-enter-link":
    'La compra de Diamantes se realiza a través del enlace:<a class="web-link" href="https://pay.tadachat.info/" >https://pay.tadachat.info</a> , copia y abre el enlace en el navegador móvil para entrar en la página de compra, comprueba la cuenta y selecciona la especificación correspondiente, luego utiliza la forma de pago adecuada-¡Precio especial!',
  "buy-notice-a":
    "Nota: <a>pay.tadachat.info</a> es el único sitio web oficial de compra de Diamantes de Tada",
  replace: "Reemplazar",
  sureBtn: "ok",
  "pay-style": "elige el método de pago",
  goBack: "Volver a la página de inicio",
  toastTips: "Introduce el ID de Tada",
  rechargeFAQ_title: "Preguntas frecuentes",
  PayStatusSuccess_title: "Transacción hecha",
  PayStatusFail_title: "Transacción fallida",
  PayStatusCancel_title: "Transacción cancelada",
  Diamonds_title: "Sitio web oficial de recarga de diamantes de Tada",
  "buy-notice":
    "Nota pay.Tadachat.info es el único sitio web oficial de compra de diamantes de Tada. Para consultas sobre servicio al cliente, vaya a [Mensaje]-[Noticias oficiales]-[Comentarios y ayuda]",
  RechargeHelp_title: "Ayuda de recarga",
  openAPP: "Abra la aplicación Tada",
  "buy-diamonds-tit": "Comprar servicios de diamantes",
  description:
    "Tada es el único sitio oficial de recarga de diamantes, Tada es un software social internacional, con usuarios de más de 150 países y regiones de todo el mundo",
  keywords:
    "Recarga de Tada, recarga de diamantes de Tada, recarga oficial de Tada, sitio web de recarga oficial de Tada",
  payforType: "Método de recarga",
  trueText: "ok",
  falseText: "cancelar",

  alertShowTxt1: "¿Seguro que utilizará",
  alertShowTxt3: "para recargar",
  alertShowTxt5: "diamantes?",

  EnterIDTip: "Recarga rápida Tada",

  scanLogin:
    "Para la privacidad y la seguridad de su cuenta, por favor inicie sesión barriendo el Código",
  scanTip:
    'Consejo: haga clic en "Centro personal / dinámica" en la esquina superior derecha de "barrido",Escaneo de código de inicio de sesión, y soporte para identificar capturas de pantalla de código bidimensional de inicio de sesión',
  scanVersion:
    "Por favor, actualice Tada a la versión %s después de iniciar sesión de barrido",
  delAccount: "Borrar cuenta",
  logout: "Cerrar sesión",

  submit: "Enviar",
  email_place_holder: "Ingrese su buzón",
  contact_email: "Correo electrónico de contacto",
  provide_email:
    "Por favor, proporcione su correo electrónico para recibir notificaciones de pago",
  email_address: "Dirección de correo electrónico",
};



// WEBPACK FOOTER //
// ./src/lang/es.js